import { z } from 'zod';
import { AuditFieldsSchema, MoneyHufSchema, TenantIdSchema } from '../types/common.types';
import { PaginationQuerySchema } from '../types/pagination.types';

export const EquipmentStatusSchema = z.enum([
  'AVAILABLE',
  'RENTED',
  'MAINTENANCE',
  'RETIRED',
  'RESERVED',
]);
export type EquipmentStatus = z.infer<typeof EquipmentStatusSchema>;

export const EquipmentTypeSchema = z
  .object({
    id: z.string().uuid(),
    tenantId: TenantIdSchema,
    name: z.string().min(1).max(255),
    description: z.string().nullable(),
    categoryId: z.string().uuid().nullable(),
    dailyRate: MoneyHufSchema,
    weeklyRate: MoneyHufSchema.nullable(),
    monthlyRate: MoneyHufSchema.nullable(),
    depositAmount: MoneyHufSchema.nullable(),
    heroImageUrl: z.string().url().nullable(),
    galleryImages: z.array(z.string().url()).default([]),
    specs: z.record(z.unknown()).default({}),
    isActive: z.boolean().default(true),
  })
  .merge(AuditFieldsSchema);
export type EquipmentType = z.infer<typeof EquipmentTypeSchema>;

export const EquipmentUnitSchema = z
  .object({
    id: z.string().uuid(),
    tenantId: TenantIdSchema,
    typeId: z.string().uuid(),
    serialNumber: z.string().nullable(),
    status: EquipmentStatusSchema,
    locationId: z.string().uuid().nullable(),
    altSkuChips: z.array(z.string()).default([]),
  })
  .merge(AuditFieldsSchema);
export type EquipmentUnit = z.infer<typeof EquipmentUnitSchema>;

// A `tenantId` NEM query-param (PR #155 / Q-T022 scope-B): a portál equipment-böngészés
// tenant-jét a szerver derive-álja (Origin/Host → tenantId, PortalTenantContextInterceptor).
// A kliens-megadott tenantId IDOR-vektor volt. A page/limit bound a PaginationQuerySchema-ból
// (limit max 100), a `days` max 90 — a contract a bound SoT-ja (a controller ZodValidationPipe-pal
// fogyaszthatja, follow-up #155-merge után).
export const PortalEquipmentListQuerySchema = PaginationQuerySchema.extend({
  category: z.string().optional(),
  search: z.string().optional(),
  locationId: z.string().uuid().optional(),
});
export type PortalEquipmentListQuery = z.infer<typeof PortalEquipmentListQuerySchema>;

export const PortalEquipmentAvailabilityQuerySchema = z.object({
  startDate: z.string().date(),
  days: z.coerce.number().int().positive().max(90),
});
export type PortalEquipmentAvailabilityQuery = z.infer<
  typeof PortalEquipmentAvailabilityQuerySchema
>;
